<script lang="ts">
  import { useActions } from "#lib/internal/helpers"
  import type { BaseProps } from "#lib/internal/types"
  import { cn } from "#lib/utils"
  import type { Snippet } from "svelte"
  import { getSelectRootContext } from "./SelectRoot.svelte"

  type Props = BaseProps<"span"> & {
    innerText?: string
    content?: HTMLSpanElement
    hiddenContent?: boolean
    children?: Snippet
  }

  /** bind-only property which will be used to derive the label for the item when one is not explicitly provided */
  let {
    innerText = $bindable(),
    content = $bindable(),
    hiddenContent = false,
    children,
    use = [],
    ...restProps
  }: Props = $props()

  let ref: HTMLSpanElement = $state()!

  const rootCtx = getSelectRootContext()

  $effect(() => {
    content = ref
    innerText = ref?.textContent?.trim() ?? ""
  })
</script>

<span
  bind:this={ref}
  use:useActions={use}
  {...restProps}
  class={cn(
    `group-data-[disabled='true']:text-general-inactive-text
    place-self-center
    overflow-hidden
    text-ellipsis
    whitespace-nowrap`,
    rootCtx.multiselect && "flex w-full flex-row gap-1",
    hiddenContent && "content-fade",
    restProps.class
  )}
>
  {@render children?.()}
</span>

<style>
  .content-fade {
    --mask: linear-gradient(
        to right,
        rgba(0, 0, 0, 1) 0,
        rgba(0, 0, 0, 1) 80%,
        rgba(0, 0, 0, 0) 90%,
        rgba(0, 0, 0, 0) 0
      )
      100% 50% / 100% 100% repeat-x;

    -webkit-mask: var(--mask);
    mask: var(--mask);
  }
</style>
